import styled from "styled-components";

interface ItemProps {
	$isActive: boolean;
}

export const MainContainer = styled.div<{ $isHidden: boolean }>`
	user-select: none;
	grid-area: sidebar;
	background-color: ${({ theme }) => theme.colors.appBlack};
	border-top-right-radius: 1.6rem;
	border-bottom-right-radius: 1.6rem;
	position: relative;
	padding: 0 0 2.4rem 0;
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	z-index: 12;

	${({ $isHidden }) => $isHidden && "overflow: hidden;"}
`;

export const TopContainer = styled.div`
	border-bottom: 1px solid ${({ theme }) => theme.colors.itemBorder};
	background-color: ${({ theme }) => theme.colors.appBlack};
	border-top-right-radius: 1.6rem;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 65px;
`;

export const ToggleButton = styled.button`
	position: absolute;
	top: 50px;
	right: -14px;
	background-color: #161a23;

	border-bottom: 1px solid ${({ theme }) => theme.colors.itemBorder};

	border-radius: 8px;
	padding: 4px;
	width: 28px;
	aspect-ratio: 1/1;
	cursor: pointer;
`;

export const SectionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	overflow: hidden;
	transition: 200ms;
`;

export const SectionHeadline = styled.div<{ $isExpanded: boolean }>`
	padding-left: calc(2.4rem + 1.2rem);
	text-align: left;
	font-size: 1.2rem;
	text-transform: uppercase;

	color: ${({ theme }) => theme.colors.textSecondary};

	cursor: default;

	${({ $isExpanded }) =>
		!$isExpanded &&
		`padding-left: unset;
		text-align: center;`}
`;

export const SectionDivider = styled.div`
	height: 1px;
	margin: 0 24px;
	background: ${({ theme }) => theme.colors.itemBorder};
`;

export const SectionSpacer = styled.div`
	height: 1px;
`;

export const ChildrenContainer = styled.div`
	padding: 0 24px;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const ItemContainer = styled.div<ItemProps>`
	padding: 1rem 1.2rem;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	gap: 12px;
	cursor: pointer;
	border-radius: 8px;
	min-height: 40px;
	background-color: transparent;

	&[data-is-active="true"] {
		background-color: #ec67286e;
	}

	${({ $isActive }) => $isActive && `background-color: #ec67286e;`}

	&:hover {
		background-color: #ec67286e;
	}

	&:hover div {
		color: ${({ theme }) => theme.colors.activeIcon};
	}
`;

export const ItemLabel = styled.div<ItemProps>`
	white-space: nowrap;
	text-transform: capitalize;
	overflow: hidden;
	font-size: 1.4rem;

	color: ${({ theme }) => theme.colors.textSecondary};

	${({ $isActive, theme }) => $isActive && `color: ${theme.colors.activeIcon};`}
`;

export const LogoutContainer = styled.div`
	margin-top: auto;
	display: flex;
	justify-content: center;
`;
